var amenitiesMap = {
  mapContainerId: 'amenities_map_container',
  mapId: 'amenities_map',
  mapStyleUrl: 'mapbox://styles/liquidmelbourne/cjanekwjz37cp2rms6lii68d6',
  mapKey: 'pk.eyJ1IjoibGlxdWlkbWVsYm91cm5lIiwiYSI6ImNqbXNnZ2o1ajAxbTYzd21yMjVpYmNtOGIifQ.iukQ2xSxuax385XC1ZJyvg',
  // mapClusterMaxZoom: 14,
  mapZoom: 14,
  featuresInit:false,
  pixelRadius: 400,

  // categories must be array
  buildListing: function(categories) {
    var _this = this;

    var list = $('#'+_this.mapContainerId).find('.amenities-list');

    // Add items to sidebar
    var markup = '';
    for (var i = 0; i < categories.length; i++ ) {
      var c = categories[i];

      var description = c.description ? '<p class="description text-small mb0">'+c.description+'</p>' : '';

      markup += [
        '<div class="item active" data-cat-id="'+c.id+'" data-colour="'+c.icon_color+'">',
          '<div class="text">',
            '<h6 class="heading" style="color:'+c.icon_color+'">'+c.title+'</h6>' + description,
          '</div>',
        '</div>',
      ].join('');

    }
    list.removeClass('empty');
    list.html(markup);


   // On click on item show/hide its markers
   list.find('.item').on('click', function() {
    var id = parseInt($(this).attr('data-cat-id'));

    var currentActive = list.find('.item.active');

    var layerId = 'cat-'+id;

    // toggle visibility of layer
    // hide features
    if ( $(this).hasClass('active') ) {
      // hide features
      _this.map.setLayoutProperty(layerId, 'visibility', 'none');
      // hide popup
      $('.mapboxgl-popup-close-button').trigger('click');
      $(this).removeClass('active');
      // remove colours
      $(this).find('.img, .heading').css('color','');
    }
    // show features
    else {
      _this.map.setLayoutProperty(layerId, 'visibility', 'visible');
      $(this).addClass('active');
      // add colours
      $(this).find('.img, .heading').css('color',$(this).attr('data-colour'));
    }


   })


  },

  // cat_ids must be array of int
  filterFeaturesByCategory: function(cat_ids) {
    var _this = this;

    var filterOptions = ['in', 'category_id'];

    for (var i = 0; i < cat_ids.length; i++ ) {
      var id = cat_ids[i].toString();
      filterOptions.push(id);
    }

    _this.map.setFilter('allAmenities', filterOptions);
  },

  showFeaturesNearby: function() {
    var _this = this;
    var x = _this.mainMarker._pos.x;
    var y = _this.mainMarker._pos.y;

    _this.bbox = [[x - _this.pixelRadius, y - _this.pixelRadius], [x + _this.pixelRadius, y + _this.pixelRadius]];
    var features = _this.map.queryRenderedFeatures(_this.bbox, { layers: ['allAmenities'] });

    var ids = [];
    _this.cat_ids = []; // needs to be accessible out of this function

    // == Remove duplicates and save uniques ids.
    var uniqueFeatures = features.filter(function(f) {
      if(ids.indexOf(f.properties.id) === -1 ) {
        // add id to ids list
        ids.push(f.properties.id);
        // save category id if not already saved
        var cat_id = parseInt(f.properties.category_id);
        if(_this.cat_ids.indexOf(cat_id) === -1){
          _this.cat_ids.push(cat_id);
        }

        // keep feature
        return f;
      }
    })

    // == Loop on all amenities and keep the ones that match ids array
    _this.nearbyFeatures = _this.allAmenities.features.filter(function(f) {
      if(ids.indexOf(f.properties.id) > -1 ) {
        return f;
      }
    });

    // Loop on all categories and keep the ones that match cat_ids
    _this.nearbyCategories = _this.allAmenityCategories.filter(function(cat) {
      if(_this.cat_ids.indexOf(cat.id) > -1 ) {
        return cat;
      }
    });


    // Create layers
    // Can not use for loop because need to wait for image to be added to the map before adding a new one.
    if ( _this.cat_ids.length > 0 ) {
      _this.createLayer(_this.cat_ids[0]);
    }

    // Hide layer with all amenities
    _this.map.setLayoutProperty('allAmenities', 'visibility', 'none');



    // Reposition map.
    var mapBounds = _this.map.getBounds();

    var options = {
      padding: {top: _this.bboxPadding, bottom:_this.bboxPadding, left: _this.bboxLeftPadding, right: _this.bboxPadding},
    }

    // Fade in map when fit bounds done.
    _this.map.once('moveend', fitBoundsEnd);

    _this.map.fitBounds(mapBounds, options);

    function fitBoundsEnd() {
      // fade in map

      // If too far: Zoom in to be closer to marker
      if ( _this.map.getZoom() < 14 ) {
        var options = {
          offset: [_this.zoomOffsetX, 0]
        }
        // zoom in
        _this.map.zoomTo(15, options);
      }


      $('#'+_this.mapContainerId).removeClass('loading');

      _this.map.off('moveend', fitBoundsEnd);
    }

  },

  createLayer: function(catId) {
    var _this = this;
    var source_id = 'amenities-'+catId;
    var layer_id = 'cat-'+catId;
    var symbol_id = 'symbol'+catId;

    // get symbol for this category.
    var cat_symbol = '';
    for (i = 0; i < _this.nearbyCategories.length; i++) {
      var cat = _this.nearbyCategories[i]
      if( parseInt(cat.id) === catId ) {
        cat_symbol = cat.map_marker;
      }
    }

    // get all amenities for this category
    var features = _this.nearbyFeatures.filter(function(amenity) {
      if( parseInt(amenity.properties.category_id) === catId ) {
        return amenity;
      }
    });

    var amenities = {
      "type": "FeatureCollection",
      "features": features
    };


    // create layout for this category
    _this.map.addSource(source_id, {
      "type": "geojson",
      "data": amenities
    });

    _this.map.loadImage(cat_symbol, function(error, image) {
      if (error) {
        console.log('cat_symbol: image not found');
        throw error;
      }
      _this.map.addImage(symbol_id, image);

      _this.map.addLayer({
        "id": layer_id,
        "type": "symbol",
        "source": source_id,
        "layout": {
          "icon-image": symbol_id,
          "icon-size": _this.symbol_size,
          "icon-allow-overlap": true
        }
      });

      // === Show popup on click on feature
      _this.map.on('click', layer_id, function (e) {
        var feature = e.features[0];

        // _this.map.flyTo({
        //   center: feature.geometry.coordinates,
        //   offset: [0, 40]
        // });

        _this.createPopUp(feature);
      });

      // === Toggle cursor pointer on hover
      _this.map.on('mouseenter', layer_id, function () {
          _this.map.getCanvas().style.cursor = 'pointer';
      });
      _this.map.on('mouseleave', layer_id, function () {
          _this.map.getCanvas().style.cursor = '';
      });

      // === Create next layout
      var i = _this.cat_ids.indexOf(catId);
      if ( _this.cat_ids[i+1] ) {
        _this.createLayer(_this.cat_ids[i+1]);
      }
    })
  },

  createPopUp: function(currentFeature) {
    var _this = this;
    var popUps = document.getElementsByClassName('mapboxgl-popup');
    // Check if there is already a popup on the map and if so, remove it
    if (popUps[0]) popUps[0].remove();

    var prop = currentFeature.properties;

    // var lngLat = [prop.locationLng, prop.locationLat];
    var lngLat = currentFeature.geometry.coordinates;
    var latLng = [currentFeature.geometry.coordinates[1], currentFeature.geometry.coordinates[0]];

    var gmaps_query = "https://maps.google.com?q=" + latLng;

    var markup = [
      '<div class="item-content">',
        '<p class="mb0 small-text">'+prop.name+'</p>',
        '<a class="item-info" href="'+ gmaps_query +'" target="_blank">View in Google Maps</a>',
      '</div>',
    ].join('');

    var popup = new mapboxgl.Popup({
      closeOnClick: true,
      anchor: 'bottom',
    })
    .setLngLat(lngLat)
    .setHTML(markup)
    .addTo(_this.map);

    // update close icon
    // $('.mapboxgl-popup-content').addClass(imgClass);
    // var path = 'http://' + window.location.hostname;
    // $('.mapboxgl-popup-close-button').html('<img alt="close" src="'+ path +'/images/mapbox/map-close.png" />');


    popup.on('close',function(){
      // _this.removeActiveListing(prop.id);
      // _this.removeActiveSymbol();
    })

  },

  setUpVariables: function() {
    var _this = this;

    // Categories
    if ( window.allAmenityCategories == undefined ) {
      _this.allAmenityCategories = null;
      return;
    } else {
      _this.allAmenityCategories = window.allAmenityCategories;
    }

    // Amenities
    if ( window.allAmenities == undefined ) {
      _this.allAmenityCategories = null;
      return;
    } else {

      var allAmenitiesFeatures = [];
      _this.allAmenities = [];

      if ( window.allAmenities.length > 0 ) {
        for (i = 0; i < allAmenities.length; i++) {
          var amenity = allAmenities[i];

          var feature = {};
          feature.type = 'Feature';
          feature.geometry = {};
          feature.geometry.type = 'Point';
          feature.geometry.coordinates = [amenity.longitude, amenity.latitude];

          feature.properties = amenity;

          allAmenitiesFeatures.push(feature);
        }

        _this.allAmenities = {
          'type': 'FeatureCollection',
          'features': allAmenitiesFeatures
        };
      }
    }

  },

  setStyleVariables: function() {
    var _this = this;

    // _this.pixelRadius = 400;

    // Amenities marker size
    _this.symbol_size = .4;

    // Bounding box options (to center amenities in map)
    var sidebarWidth = parseInt($('#'+_this.mapContainerId).find('.amenities-list').outerWidth(), 10);

    _this.bboxPadding = 60;
    _this.bboxLeftPadding = _this.pixelRadius - (sidebarWidth/2); // sidebar width
    // _this.bboxLeftPadding = _this.bboxPadding;
    _this.zoomOffsetX = 155; // sidebar is 370px
    // _this.zoomOffsetX = (sidebarWidth/2) - (_this.bboxPadding/2); // (370/2) - 30

    if ( Modernizr.mq("screen and (max-width:"+bp_widescreen+"px)")) {
      _this.pixelRadius = 340;
    }
    if ( Modernizr.mq("screen and (max-width:"+bp_large_desktop+"px)")) {
      _this.pixelRadius = 300;
      _this.zoomOffsetX = 165; // sidebar is 350px
      // _this.zoomOffsetX = (sidebarWidth/2) - (_this.bboxPadding/2);
      // (350/2) - 10
    }
    if ( Modernizr.mq("screen and (max-width:"+bp_med_desktop+"px)")) {
      _this.pixelRadius = 250;
      _this.bboxPadding = 40;
      _this.bboxLeftPadding = _this.pixelRadius - (sidebarWidth/2) + _this.bboxPadding;
      // _this.bboxLeftPadding = _this.bboxPadding;
      // _this.zoomOffsetX = (sidebarWidth/2) - (_this.bboxPadding/2);
      _this.zoomOffsetX = 90; // sidebar is 320px

      _this.symbol_size = .32;

      _this.mapZoom = 13;
    }
    if ( Modernizr.mq("screen and (max-width:"+bp_desktop+"px)")) {
      _this.symbol_size = .3;
      _this.zoomOffsetX = 100; // sidebar is 300px
    }
    // mobile
    if ( Modernizr.mq("screen and (max-width:"+bp_tablet_landscape+"px)")) {
      _this.pixelRadius = 120;
      _this.bboxPadding = 20;
      _this.bboxLeftPadding = _this.bboxPadding;

      _this.symbol_size = .24;

      _this.mapZoom = 12;
      _this.zoomOffsetX = 0;
    }
    if ( Modernizr.mq("screen and (max-width:"+bp_tablet_portrait+"px)")) {
      _this.pixelRadius = 100;
      _this.bboxPadding = 20;
      _this.bboxLeftPadding = _this.bboxPadding;
      _this.zoomOffsetX = 0;

      // _this.mapZoom = 11;
    }

  },

  init: function() {
    var _this = this;

    mapboxgl.accessToken = _this.mapKey;

    if ( $('#' + _this.mapId).length < 1 ) { return; }

    _this.setUpVariables();
    _this.setStyleVariables();

    var mapEl = $('#' + _this.mapId);

    _this.centerLat = mapEl.attr('data-listing-lat');
    _this.centerLng = mapEl.attr('data-listing-lng');

    _this.mapCenter = {
      lng: _this.centerLng,
      lat: _this.centerLat
    }

    _this.map = new mapboxgl.Map({
      // container id specified in the HTML
      container: _this.mapId,
      style: _this.mapStyleUrl,
      // style: 'mapbox://styles/mapbox/light-v9',
      center: _this.mapCenter,
      zoom: _this.mapZoom,
      attributionControl: false,
      scrollZoom: false
    });

    // disable map rotation using right click + drag
    _this.map.dragRotate.disable();
    // disable map rotation using touch rotation gesture
    _this.map.touchZoomRotate.disableRotation();

    if ($('html').hasClass('touch')) {
      _this.map.dragPan.disable();
    }

    $(window).smartresize(function(){
      _this.setStyleVariables();
        if ($('html').hasClass('touch')) {
        _this.map.dragPan.disable();
      }
    });


    _this.map.on('load',function(e) {

      // === Add listing marker
      var el = document.createElement('div');
      el.className = 'marker';

      _this.mainMarker = new mapboxgl.Marker(el)
        .setLngLat(_this.mapCenter)
        .addTo(_this.map);

      // ==== Add all amenities to the map
      // they will not display but we need the layer to get the nearby ones.
      _this.map.addSource("amenities", {
        "type": "geojson",
        "data": _this.allAmenities
      });

      _this.map.addLayer({
        'id': 'allAmenities',
        'type': 'circle',
        'source': 'amenities',
        'layout': {
          // 'visibility': 'hidden'
        },
        'paint': {
          'circle-radius': 8,
          'circle-color': 'rgba(00,101,189,0)' // nothing showing on the map
        }
      });


      // === When map renders and features are there
      _this.map.on('render',function(e) {


        if ( !_this.map.getLayer('allAmenities') || _this.featuresInit ) { return; }

        // if no features in view
        if (  _this.map.queryRenderedFeatures({ layers: ['allAmenities'] }).length < 1 ) {
          // show map anyway
          $('#'+_this.mapContainerId).removeClass('loading');
          return;
        }

        _this.featuresInit = true;


        // === Get features that are around this product/project
        _this.showFeaturesNearby();


        // === Show these features categories.
        _this.buildListing(_this.nearbyCategories);

      });



      // on zoom: close popup
      _this.map.on('zoomstart',function(e) {
        // hide popup
        $('.mapboxgl-popup-close-button').trigger('click');
      })

      // on zoom in/out
      var zoomControls = $('#'+_this.mapContainerId).find('.zoom-controls .control');
      zoomControls.on('click', function(e) {
        e.preventDefault();
        var options = {
          offset: [_this.zoomOffsetX, 0]
        }
        // zoom in
        if ( $(this).hasClass('zoom-in') ) {
          _this.map.zoomIn(options);
        }
        // zoom out
        else if ( $(this).hasClass('zoom-out') ) {
          _this.map.zoomOut(options);
        }
      })

    });

  },
  destroy: function() {
    if ( this.featuresInit == false ) { return; }
    this.map.remove();
    this.featuresInit = false;
  }
}




// LOGIC
/*

Get project coordinates.
Get all amenities that are in a radius of 5km around this location

Project is black pin

Create layers for amenities categories.

Amenities markers: icon of category + popup on click with name and link to google maps.

Show all layers by default.
Can unselect layer by clicking on it.



*/
